/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Generator — Strong Random Passwords | Toolverse`)
};

const es_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Contraseñas — Contraseñas Aleatorias Fuertes | Toolverse`)
};

const de_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwortgenerator — Starke Zufallspasswörter | Toolverse`)
};

const nl_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoordgenerator — Sterke willekeurige wachtwoorden | Toolverse`)
};

const fr_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de mot de passe — Mots de passe aléatoires forts | Toolverse`)
};

const it_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di password — Password casuali forti | Toolverse`)
};

const pt_br2_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Senhas — Senhas Aleatórias Fortes | Toolverse`)
};

const pt_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Senhas — Senhas Aleatórias Fortes | Toolverse`)
};

const ja_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードジェネレーター — 強力でランダムなパスワード | Toolverse`)
};

const zh_pw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码生成器 — 强随机密码 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_meta_title", locale)
	if (locale === "en") return en_pw_meta_title(inputs)
	if (locale === "es") return es_pw_meta_title(inputs)
	if (locale === "de") return de_pw_meta_title(inputs)
	if (locale === "nl") return nl_pw_meta_title(inputs)
	if (locale === "fr") return fr_pw_meta_title(inputs)
	if (locale === "it") return it_pw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_pw_meta_title(inputs)
	if (locale === "pt") return pt_pw_meta_title(inputs)
	if (locale === "ja") return ja_pw_meta_title(inputs)
	return zh_pw_meta_title(inputs)
};